import { render, staticRenderFns } from "./VideoBoxLogo.vue?vue&type=template&id=fc0f3240&scoped=true"
import script from "./VideoBoxLogo.vue?vue&type=script&lang=js"
export * from "./VideoBoxLogo.vue?vue&type=script&lang=js"
import style0 from "./VideoBoxLogo.vue?vue&type=style&index=0&id=fc0f3240&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0f3240",
  null
  
)

export default component.exports